import { StepContainer } from '../components/StepContainer'
import { MultiSelect } from '../components/MultiSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { Comorbidity } from '../types/onboarding'
import { MultiSelectV2 } from '../components/v2'
import { usesAppLook } from '../lib/variant'

const options: { value: Comorbidity; label: string; emoji: string }[] = [
  { value: 'diabetes', label: 'Diabetes', emoji: '💉' },
  { value: 'high_blood_pressure', label: 'High Blood Pressure', emoji: '❤️‍🩹' },
  { value: 'heart_disease', label: 'Heart Disease', emoji: '🫀' },
  { value: 'gout', label: 'Gout', emoji: '🦶' },
  { value: 'anemia', label: 'Anemia', emoji: '🩸' },
  { value: 'bone_disease', label: 'Bone Disease', emoji: '🦴' },
  { value: 'none', label: 'None', emoji: '✅' },
]

// organic-v2: the app's condition marks (constants/kidney.ts).
const V2_ICONS: Record<Comorbidity, string> = {
  diabetes: 'comorbid-diabetes',
  high_blood_pressure: 'comorbid-hypertension',
  heart_disease: 'comorbid-heart-disease',
  gout: 'comorbid-gout',
  anemia: 'comorbid-anemia',
  bone_disease: 'comorbid-bone-disease',
  none: 'kidney-healthy',
}
const v2Options = options.map(({ value, label }) => ({ value, label, icon: V2_ICONS[value] }))

export function ComorbiditiesStep() {
  const { data, updateData, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="Any other conditions?"
      subtitle="Select all that apply - this adjusts your nutrient limits"
      onContinue={() => goNext()}
      continueDisabled={data.comorbidities.length === 0}
    >
      {usesAppLook() ? (
        <MultiSelectV2
          options={v2Options}
          values={data.comorbidities}
          onChange={(values) => updateData({ comorbidities: values })}
        />
      ) : (
        <MultiSelect
          options={options}
          values={data.comorbidities}
          onChange={(values) => updateData({ comorbidities: values })}
        />
      )}
    </StepContainer>
  )
}
